export default "__VITE_ASSET__anMGew12__"